import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SupportAgentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"support_agent"}/>
}
